/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Assesment In Psychology List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AssesmentInPsychologyListView';

export const mapStateToPropsAssesmentInPsychologyList = mapStateToProps;
export const mapDispatchToPropsAssesmentInPsychologyList = mapDispatchToProps;

export default connect(
  mapStateToPropsAssesmentInPsychologyList,
  mapDispatchToPropsAssesmentInPsychologyList
)(View);
